import TimelineAPI, {
  GetUserAssistanceParams,
  UserAssistanceResponse,
  GetStorageParams,
  GetSandboxParams,
  GetSandboxResponse,
  PostStorageTickParams,
  RevertStorageSandboxParams
} from '../requests/timeline';

/** 获取助教求助信息 */
export async function getUserAssistance(
  data: GetUserAssistanceParams
): Promise<UserAssistanceResponse> {
  const res = await TimelineAPI.getUserAssistance(data);
  return res.data;
}

/** 获取获取 storage 跟 token */
export async function getStorage() {
  return TimelineAPI.getStorage();
}

export async function getSandbox(params: GetSandboxParams): Promise<GetSandboxResponse> {
  const res = await TimelineAPI.getSandbox(params);
  return res.data;
}

export async function postStorageTick(data: PostStorageTickParams) {
  return TimelineAPI.postStorageTick(data);
}

export async function revertStorageSandbox(data: RevertStorageSandboxParams, sync?: boolean) {
  return TimelineAPI.revertStorageSandbox(data, sync);
}
